import { render, staticRenderFns } from "./wsOnboardWrapper.vue?vue&type=template&id=099444ce&scoped=true&"
import script from "./wsOnboardWrapper.vue?vue&type=script&lang=js&"
export * from "./wsOnboardWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099444ce",
  null
  
)

export default component.exports